import { apiClient } from '@/api/client'
import type {
  ConsumoMeta,
  ConsumoMetaCreateInput,
  ConsumoMetaFilters,
  ConsumoMetaUpdateInput,
} from '../types/consumoMeta'

const BASE = '/consumo-meta'

export async function getConsumoMeta(filters?: ConsumoMetaFilters): Promise<ConsumoMeta[]> {
  const { data } = await apiClient.get<ConsumoMeta[]>(`${BASE}/`, { params: filters })
  return data
}

export async function createConsumoMeta(payload: ConsumoMetaCreateInput): Promise<ConsumoMeta> {
  const { data } = await apiClient.post<ConsumoMeta>(`${BASE}/`, payload)
  return data
}

export async function updateConsumoMeta(id: number, payload: ConsumoMetaUpdateInput): Promise<ConsumoMeta> {
  const { data } = await apiClient.put<ConsumoMeta>(`${BASE}/${id}/`, payload)
  return data
}

export async function deleteConsumoMeta(id: number): Promise<void> {
  await apiClient.delete(`${BASE}/${id}/`)
}
